module.exports = [{"name":"PRIME_PRT1349D","version":1}]